import { useState } from 'react';
import {
    InputNumber as PrimeReactInputNumber,
    InputNumberProps as PrimeReactInputNumberProps,
} from 'primereact/inputnumber';

import './style.css';
import renderIsRequired from '../utils/renderIsRequired';

export interface IInputNumber extends PrimeReactInputNumberProps {
    label?: string;
    labelStyle?: React.CSSProperties;
    error?: string | null;
    validations?: {
        validate: (value?: number | null) => boolean;
        validationError?: string;
    }[];
    validationCallback?(isValid: boolean, error: string | null): void;
    required?: boolean;
    wrapperStyle?: React.CSSProperties;
}

export const InputNumber: React.FC<IInputNumber> = ({
    label,
    name,
    labelStyle,
    error,
    validations,
    validationCallback,
    required,
    ...rest
}) => {
    const [validationError, setValidationError] = useState<string | null>(null);

    const validate = (value?: number | null) => {
        if (!validations) return true;
        const notValid = validations.find((v) => {
            return !v.validate(value);
        });
        const errorMessage = notValid
            ? notValid.validationError ?? 'Validation error'
            : null;
        if (errorMessage) {
            setValidationError(errorMessage);
        } else setValidationError(null);
        if (validationCallback) validationCallback(!notValid, errorMessage);
    };

    return (
        <div className='custom-input-number' style={rest.wrapperStyle}>
            <span>
                <label
                    htmlFor={name}
                    style={{
                        marginRight: '8px',
                        display: label ? 'inherit' : 'none',
                        ...labelStyle,
                    }}
                >
                    {label}
                    {renderIsRequired(required)}
                </label>
                <PrimeReactInputNumber
                    {...rest}
                    onChange={(e) => {
                        validate(e.value);
                        if (rest.onChange) rest.onChange(e);
                    }}
                    className={
                        rest.className +
                        (validationError || error ? '  p-invalid' : '')
                    }
                />
                {error && (
                    <small
                        id={`${name}-help`}
                        className='p-error block input-number-error'
                    >
                        {error}
                    </small>
                )}
                {validationError && (
                    <small
                        id={`${name}-help`}
                        className='p-error block input-number-error'
                    >
                        {validationError}
                    </small>
                )}
            </span>
        </div>
    );
};
